import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { initializeApp } from "firebase/app";
import { apiKey, appId, authDomain, measurementId, messagingSenderId, projectId, storageBucket, vapidKey } from "API/client/api";
import ringSound from "./notification.mp3";

const firebaseConfig = {
  apiKey: apiKey,
  authDomain: authDomain,
  projectId: projectId,
  storageBucket: storageBucket,
  messagingSenderId: messagingSenderId,
  appId: appId,
  measurementId: measurementId,
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
// const messaging = '1';

export const getFirebaseToken = async () => {
  try {
    const permission = await Notification?.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission not granted:", permission);
      return null;
    }
    const token = await getToken(messaging, {
      vapidKey: vapidKey
    });
    return token;
  } catch (err) {
    return null;
  }
};

export const onNotificationListener = () =>
  new Promise((resolve) => {
    // onMessage(messaging, (payload) => {
    //   const audio = new Audio(ringSound);
    //   audio.play().catch((err) => console.log("Autoplay blocked:", err));
    //   resolve(payload);
    // });
    onMessage(messaging, (payload) => {
      const audio = new Audio("/notification.mp3");
      audio.loop = true;
      audio.play().catch(() => { });
    });
  });
